import React, { useState, useEffect } from "react";
import axios from "axios";
import Layout from "../components/Layout/Layout";
import BannerHeroSection from "../components/HeroSection/BannerHeroSection";
import TrainingHero from "../assets/TrainingHero.png";
import { motion } from "framer-motion";
import verticalDots from "../assets/verticalDots.svg";
import homeIcon from "../assets/homeIcon.svg";
import clock from "../assets/clock.svg";
import person from "../assets/person.svg";
import computerIcon from "../assets/computerIcon.svg";
import coffeeIcon from "../assets/coffeeIcon.svg";
import verticalRedLine from "../assets/verticalRedLine.svg";

const AboutUs = () => {
  const [aboutus, setAboutus] = useState([]);

  useEffect(() => {
    const getAboutusContent = () => {
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/aboutus`)
        .then((response) => {
          setAboutus(response?.data[0]);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    };
    getAboutusContent();
  }, []);

  const bubbleSVG = (
    <svg viewBox="0 0 165 165" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="165"
        y="165"
        width="165"
        height="165"
        rx="82.5"
        transform="rotate(180 165 165)"
        fill="#E9EFFF"
      />
    </svg>
  );

  const bubbleSVG2 = (
    <svg
      width="58"
      height="83"
      viewBox="0 0 58 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="83"
        height="83"
        rx="41.5"
        transform="matrix(1 0 0 -1 0 83)"
        fill="#E9EFFF"
      />
    </svg>
  );

  const smallBubbleSVG = (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="35" height="35" rx="17.5" fill="#E9EFFF" />
    </svg>
  );

  return (
    <Layout>
      <div className="overflow-hidden">
        <BannerHeroSection
          title="About Us"
          subtitle="Discover our story, mission, and commitment to professional safety training excellence"
          bannerImage={TrainingHero}
          height="h-64 md:h-80 lg:h-96 xl:h-[500px]"
          className="-mx-4 md:-mx-12 lg:-mx-16 mb-6 md:mb-8 lg:mb-10"
          showOverlay={true}
        />

        {/* Stats Section */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative flex m-auto max-w-[1050px] md:h-[220px] h-[213px] lg:z-[9999] -mt-10"
        >
          <div className="relative bg-white flex lg:justify-normal justify-center flex-wrap m-auto max-w-[1050px] md:h-[260px] h-[213px] shadow-xl rounded-lg border border-gray-100">
            <div className="flex justify-around md:w-[205px] w-[122px]">
              <div className="flex flex-col justify-around">
                <motion.div
                  initial={{ scale: 0 }}
                  whileInView={{ scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.1 }}
                  className="flex justify-center"
                >
                  <img
                    className="md:w-[47px] md:h-[43px] w-[23.87px] h-[23.87px]"
                    src={homeIcon}
                    alt="home icon"
                  />
                </motion.div>
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="md:text-[32.11px] text-[19.09px] md:leading-[32.11px] leading-[19.09px] font-semibold text-center text-[#183864]"
                >
                  {aboutus?.campuses || "6"}
                </motion.div>
                <div className="md:text-[12.84px] text-[7.64px] md:leading-[19.27px] leading-[11.46px] font-medium text-center text-gray-600">
                  Campuses
                </div>
              </div>
              <div className="flex justify-center items-center">
                <img
                  className="md:h-[128px] h-[70px]"
                  src={verticalRedLine}
                  alt=""
                />
              </div>
            </div>

            <div className="flex justify-around md:w-[205px] w-[122px]">
              <div className="flex flex-col justify-around">
                <motion.div
                  initial={{ scale: 0 }}
                  whileInView={{ scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="flex justify-center"
                >
                  <img
                    className="md:w-[41px] md:h-[42px] w-[23.87px] h-[23.87px]"
                    src={clock}
                    alt="clock icon"
                  />
                </motion.div>
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.3 }}
                  className="md:text-[32.11px] text-[19.09px] md:leading-[32.11px] leading-[19.09px] font-semibold text-center text-[#183864]"
                >
                  {aboutus?.yearsExperience || "25"}+
                </motion.div>
                <div className="md:text-[12.84px] text-[7.64px] md:leading-[19.27px] leading-[11.46px] font-medium text-center text-gray-600">
                  Years of experience
                </div>
              </div>
              <div className="flex justify-center items-center">
                <img
                  className="md:h-[128px] h-[70px]"
                  src={verticalRedLine}
                  alt=""
                />
              </div>
            </div>

            <div className="flex justify-around md:w-[205px] w-[122px]">
              <div className="flex flex-col justify-around">
                <motion.div
                  initial={{ scale: 0 }}
                  whileInView={{ scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.3 }}
                  className="flex justify-center"
                >
                  <img
                    className="md:w-[41px] md:h-[43px] w-[23.87px] h-[23.87px]"
                    src={person}
                    alt="person icon"
                  />
                </motion.div>
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                  className="md:text-[32.11px] text-[19.09px] md:leading-[32.11px] leading-[19.09px] font-semibold text-center text-[#183864]"
                >
                  {aboutus?.instructors || "50"}+
                </motion.div>
                <div className="md:text-[12.84px] text-[7.64px] md:leading-[19.27px] leading-[11.46px] font-medium text-center text-gray-600">
                  Instructors
                </div>
              </div>
              <div className="flex justify-center items-center">
                <img
                  className="md:h-[128px] h-[70px]"
                  src={verticalRedLine}
                  alt=""
                />
              </div>
            </div>

            <div className="flex justify-around md:w-[205px] w-[122px]">
              <div className="flex flex-col justify-around">
                <motion.div
                  initial={{ scale: 0 }}
                  whileInView={{ scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                  className="flex justify-center"
                >
                  <img
                    className="md:w-[70px] md:h-[52px] w-[23.87px] h-[23.87px]"
                    src={computerIcon}
                    alt="computer icon"
                  />
                </motion.div>
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.5 }}
                  className="md:text-[32.11px] text-[19.09px] md:leading-[32.11px] leading-[19.09px] font-semibold text-center text-[#183864]"
                >
                  {aboutus?.courses || "100"}+
                </motion.div>
                <div className="md:text-[12.84px] text-[7.64px] md:leading-[19.27px] leading-[11.46px] font-medium text-center text-gray-600">
                  Courses
                </div>
              </div>
              <div className="flex justify-center items-center">
                <img
                  className="md:h-[128px] h-[70px]"
                  src={verticalRedLine}
                  alt=""
                />
              </div>
            </div>

            <div className="flex justify-around md:w-[205px] w-[122px]">
              <div className="flex flex-col justify-around">
                <motion.div
                  initial={{ scale: 0 }}
                  whileInView={{ scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.5 }}
                  className="flex justify-center"
                >
                  <img
                    className="md:w-[52px] md:h-[42px] w-[23.87px] h-[23.87px]"
                    src={coffeeIcon}
                    alt="coffee icon"
                  />
                </motion.div>
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.6 }}
                  className="md:text-[32.11px] text-[19.09px] md:leading-[32.11px] leading-[19.09px] font-semibold text-center text-[#183864]"
                >
                  {aboutus?.coffeeConsumed || "10,000"}
                </motion.div>
                <div className="md:text-[12.84px] text-[7.64px] md:leading-[19.27px] leading-[11.46px] font-medium text-center text-gray-600">
                  Free Coffee Consumed
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Main Content Section */}
        <div className="relative m-auto max-w-[1052px] mt-20 mb-16">
          <div className="lg:w-[165px] lg:h-[165px] w-[45px] h-[45px] absolute left-3 lg:left-[-8%] top-[-5%] lg:top-[-10%] opacity-30">
            {bubbleSVG}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="w-[85%] lg:w-full m-auto max-w-[1052px]"
          >
            <div className="text-center mb-12">
              <h2 className="text-[#183864] font-bold text-2xl md:text-3xl lg:text-4xl mb-4">
                Our Story
              </h2>
              <div className="w-20 h-1 bg-red-500 mx-auto mb-8"></div>
            </div>

            <div className="text-sm leading-[21px] font-light md:text-base md:leading-[25px] lg:text-[20px] lg:leading-[32px] text-justify text-[#183864] bg-gradient-to-r from-blue-50 to-white p-8 rounded-xl shadow-lg">
              {aboutus?.description ||
                `ProSafe First Aid Training School has been providing first aid training since 1999. 
                We have 6 Campuses located in Surrey, Abbotsford, Burnaby, Vancouver, Port Coquitlam, and Richmond. 
                While ProSafe is known for delivering First Aid training courses, we also offer classes in health 
                and safety, mobile equipment operation, workplace safety and customer service. 
                In addition to training services, we also supply first aid supplies and equipment. 
                Our professional and experienced instructors at ProSafe take pride in delivering the highest 
                quality of training and offering flexible program scheduling in multiple languages!`}
            </div>
          </motion.div>

          <div className="md:w-[85px] w-[65px] absolute right-[-35px] lg:right-[-20px] bottom-[-15%] lg:z-50 opacity-60">
            <img src={verticalDots} alt="" />
          </div>
        </div>

        {/* Mission & Vision Section */}
        <div className="relative m-auto max-w-[1052px] mt-24 mb-16">
          <div className="w-[58px] h-[83px] absolute right-3 lg:right-[-5%] top-[10%] opacity-40">
            {bubbleSVG2}
          </div>

          <div className="text-center mb-12">
            <h2 className="text-[#183864] font-bold text-2xl md:text-3xl lg:text-4xl mb-4">
              Mission & Vision
            </h2>
            <div className="w-20 h-1 bg-red-500 mx-auto mb-8"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 w-[85%] lg:w-full m-auto">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="relative bg-white p-8 rounded-xl shadow-xl border-l-4 border-red-500 hover:shadow-2xl transition-shadow duration-300"
            >
              <div className="absolute top-4 right-4 opacity-20">
                {smallBubbleSVG}
              </div>
              <h3 className="text-[#183864] font-bold text-xl md:text-2xl lg:text-3xl mb-6">
                Our Mission
              </h3>
              <p className="text-[#183864] text-sm md:text-base lg:text-lg leading-relaxed">
                To provide comprehensive, high-quality first aid and safety
                training that empowers individuals and organizations to respond
                effectively in emergency situations and create safer workplaces.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="relative bg-white p-8 rounded-xl shadow-xl border-l-4 border-blue-500 hover:shadow-2xl transition-shadow duration-300"
            >
              <div className="absolute top-4 right-4 opacity-20">
                {smallBubbleSVG}
              </div>
              <h3 className="text-[#183864] font-bold text-xl md:text-2xl lg:text-3xl mb-6">
                Our Vision
              </h3>
              <p className="text-[#183864] text-sm md:text-base lg:text-lg leading-relaxed">
                To be the leading provider of safety training in British
                Columbia, recognized for excellence, innovation, and our
                commitment to saving lives through education.
              </p>
            </motion.div>
          </div>
        </div>

        {/* Values Section */}
        <div className="relative m-auto max-w-[1052px] mt-24 mb-16">
          <div className="absolute left-0 top-10 opacity-20">{bubbleSVG}</div>

          <div className="text-center mb-12">
            <h2 className="text-[#183864] font-bold text-2xl md:text-3xl lg:text-4xl mb-4">
              Our Core Values
            </h2>
            <div className="w-20 h-1 bg-red-500 mx-auto mb-8"></div>
          </div>

          <div className="grid md:grid-cols-3 gap-6 w-[85%] lg:w-full m-auto">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="text-center p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-red-500 text-2xl font-bold">E</span>
              </div>
              <h4 className="text-[#183864] font-semibold text-lg mb-3">
                Excellence
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                We strive for the highest standards in everything we do, from
                training delivery to customer service.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-center p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-blue-500 text-2xl font-bold">S</span>
              </div>
              <h4 className="text-[#183864] font-semibold text-lg mb-3">
                Safety
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Safety is at the core of everything we teach, ensuring our
                students are well-prepared for emergencies.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="text-center p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-green-500 text-2xl font-bold">I</span>
              </div>
              <h4 className="text-[#183864] font-semibold text-lg mb-3">
                Innovation
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                We continuously update our methods and materials to provide the
                most current and effective training.
              </p>
            </motion.div>
          </div>
        </div>

        {/* Why Choose Us Section */}
        <div className="relative m-auto max-w-[1052px] mt-24 mb-16">
          <div className="absolute right-0 top-20 opacity-20">{bubbleSVG2}</div>

          <div className="text-center mb-12">
            <h2 className="text-[#183864] font-bold text-2xl md:text-3xl lg:text-4xl mb-4">
              Why Choose ProSafe?
            </h2>
            <div className="w-20 h-1 bg-red-500 mx-auto mb-8"></div>
          </div>

          <div className="w-[85%] lg:w-full m-auto">
            <div className="grid md:grid-cols-2 gap-8">
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="space-y-6"
              >
                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 bg-red-500 rounded-full flex-shrink-0 mt-1"></div>
                  <div>
                    <h4 className="text-[#183864] font-semibold text-lg mb-2">
                      Experienced Instructors
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      Our team of professional instructors brings years of
                      real-world experience to every training session.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 bg-blue-500 rounded-full flex-shrink-0 mt-1"></div>
                  <div>
                    <h4 className="text-[#183864] font-semibold text-lg mb-2">
                      Flexible Scheduling
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      We offer convenient scheduling options to fit your busy
                      lifestyle and work requirements.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 bg-green-500 rounded-full flex-shrink-0 mt-1"></div>
                  <div>
                    <h4 className="text-[#183864] font-semibold text-lg mb-2">
                      Multiple Languages
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      Training available in multiple languages to serve our
                      diverse community effectively.
                    </p>
                  </div>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="space-y-6"
              >
                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 bg-purple-500 rounded-full flex-shrink-0 mt-1"></div>
                  <div>
                    <h4 className="text-[#183864] font-semibold text-lg mb-2">
                      Comprehensive Training
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      From basic first aid to advanced workplace safety, we
                      cover all your training needs.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 bg-orange-500 rounded-full flex-shrink-0 mt-1"></div>
                  <div>
                    <h4 className="text-[#183864] font-semibold text-lg mb-2">
                      Multiple Locations
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      Six convenient campus locations across the Lower Mainland
                      for easy access.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 bg-teal-500 rounded-full flex-shrink-0 mt-1"></div>
                  <div>
                    <h4 className="text-[#183864] font-semibold text-lg mb-2">
                      Equipment & Supplies
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      Complete first aid supplies and equipment available for
                      purchase and rental.
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AboutUs;
